import React from 'react';
import Filter from '.';
import { useDocumentContext } from '../Document/context';
import { Segment } from '../../utils/segments';
import styles from './Filter.Overview.module.css';

export default function FilterOverview() {
  const { selectedSegmentId } = useDocumentContext();
  const handleFormSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  return (
    <div className="filter-form-grid">
      <form
        className={styles.filterOverviewBase}
        id="filter-form"
        onSubmit={handleFormSubmit}
      >
        <Filter.Form.Period />
        {selectedSegmentId == Segment.MAIN && (
          <>
            <Filter.Form.ContractNumbers />
            <Filter.Form.Products />
            <Filter.Form.Categories />
          </>
        )}
      </form>
    </div>
  );
}
